import React from 'react';
import { IconArrowRight } from '@tabler/icons-react';
export function HeroSection() {
  return <section className="relative py-24 md:py-32 px-5 md:px-10 w-full overflow-hidden pt-[60px] pb-[60px]" style={{
    background: '#002ca5'
  }} data-id="element-130">
      {/* Pink glow — top right */}
      <div className="absolute pointer-events-none" style={{
      width: '400px',
      height: '400px',
      top: '-80px',
      right: '-80px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(255,64,129,0.06) 0%, transparent 70%)'
    }} data-id="element-131" />

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-12 md:gap-16 items-center" data-id="element-132">
        {/* Left — Text (60%) */}
        <div className="md:col-span-3 flex flex-col items-start pr-[20px]" data-id="element-133">
          {/* Eyebrow */}
          <p className="font-body text-sm uppercase tracking-widest text-white/70 mb-4" data-id="element-134">
            Un nuovo modo di gestire i tuoi B&amp;B
          </p>

          <h1 className="font-heading md:text-[3.1em] text-white font-[600] text-[36px]" style={{
          lineHeight: 1.1
        }} data-id="element-135">
            Il primo servizio di
            <br data-id="element-136" />
            pulizie e manutenzione
            <br data-id="element-137" />
            per B&amp;B{' '}
            <span className="relative inline-block" style={{
            color: '#FF4081'
          }} data-id="element-138">
              in Sharing.
              <svg className="absolute left-0 w-full pt-[4px] mt-[10px]" style={{
              bottom: '-4px',
              height: '12px'
            }} viewBox="0 0 200 12" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" data-id="element-139">
                <path d="M2 9 Q100 2 198 8" stroke="#FF4081" strokeWidth="3.5" strokeLinecap="round" fill="none" opacity="0.7" data-id="element-140" />
              </svg>
            </span>
          </h1>

          <p className="font-body text-lg md:text-xl mt-6 max-w-2xl leading-relaxed" style={{
          color: 'rgba(255,255,255,0.8)'
        }} data-id="element-141">
            Non è un marketplace. CleanAI aggrega le richieste degli host nella
            stessa zona, costruisce percorsi ottimizzati e abbatte il costo per
            tutti — senza abbassare la qualità.
          </p>

          <button onClick={() => document.getElementById('waitlist-form')?.scrollIntoView({
          behavior: 'smooth'
        })} className="mt-8 rounded-full px-8 py-3.5 uppercase tracking-wide hover:opacity-90 transition-opacity text-[14px] font-[500]" style={{
          backgroundColor: '#69ddff',
          color: '#000b29'
        }} data-id="element-142">
            Entra nella waitlist
            <IconArrowRight size={16} stroke={2} className="inline ml-1.5" data-id="element-143" />
          </button>
        </div>

        {/* Right — Illustration placeholder (40%) */}
        <div className="md:col-span-2 flex items-center justify-center mt-4 md:mt-0" data-id="element-144">
          <img src="https://cdn.magicpatterns.com/uploads/4raXt9qXqk1GRnVQf7bcNC/765shots_so.png" alt="CleanAI app dashboard showing operator found screen" className="w-full h-auto object-contain max-h-[280px] md:max-h-[960px] md:scale-150 md:translate-x-[20%] md:origin-right" data-id="element-145" />
        </div>
      </div>
    </section>;
}